module.exports = __webpack_public_path__ + "img/utility_favorite.5d67e7db.png";